import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useUploadResource } from "../hooks/queries/useResources";
import { ROUTES } from "../constants";

const BRANCHES = [
    "Computer Science",
    "Information Technology",
    "Electronics and Telecommunication",
    "Mechanical",
    "Civil",
    "Other",
];

const MATERIAL_TYPES = [
    "Notes",
    "Question Paper",
    "Practical File",
    "Ebook",
    "Syllabus",
];

const useUploadResourceFacade = () => {
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.user);

    const [isUploading, setIsUploading] = useState(false);
    const [progress, setProgress] = useState(0);

    const [formData, setFormData] = useState({
        branch: "",
        subject: "",
        topic: "",
        materialType: "",
        contributor: user ? user.name : "Anonymous",
        downloadURL: "",
        fileSize: 0,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 20 * 1024 * 1024) {
            return alert("File is too large! Maximum limit is 20MB.");
        }

        const storage = getStorage();
        const storageRef = ref(storage, `resources/${Date.now()}_${file.name}`);
        const uploadTask = uploadBytesResumable(storageRef, file);

        setIsUploading(true);
        const fileSizeInMB = parseFloat((file.size / (1024 * 1024)).toFixed(2));

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const p = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                setProgress(p);
            },
            (error) => {
                console.error(error);
                setIsUploading(false);
                alert("Upload failed. Please try again.");
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    setFormData((prev) => ({ ...prev, downloadURL, fileSize: fileSizeInMB }));
                    setIsUploading(false);
                });
            }
        );
    };

    const uploadResource = useUploadResource();

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!formData.downloadURL) return alert("Please wait for file upload to complete");

        try {
            await uploadResource.mutateAsync(formData);
            navigate(ROUTES.resources);
        } catch (err) {
            console.error(err);
            alert("Error saving resource to database.");
        }
    };

    return {
        formData,
        isUploading,
        progress,
        branches: BRANCHES,
        materialTypes: MATERIAL_TYPES,
        handleChange,
        handleFileChange,
        handleFormSubmit,
        navigate,
    };
};

export default useUploadResourceFacade;
